export type AuditAssetsUploadRequestBody = {
  auditId: string;
  categoryId: string;
  paramDefinitionId: string;
  imageId: string | null;
  updatedAt: string | null;
  metaValue: string | null;
  directoryId?: string | null;
};
